import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import siteData, { managementTeam, testimonials } from '../Data/siteData';
import { ArrowLeftOutlined } from '@ant-design/icons';

const TestimonialPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const dataId = searchParams.get('from') || 'No Data Passed';
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const member = managementTeam.find((m) => m.id === dataId);
  const message = (testimonials as Record<string, string>)[dataId];

  if (!member) {
    return <div />;
  }

  return (
    <div className="about-container">
      <div className="content-left">
        <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack} />Go back
        </p>
        <img src={member.src} alt="Profile" className="profile-picture" />
        <div style={{ whiteSpace: 'pre-line' }}>{message}</div>
      </div>
      <div className="letter-footer">
        <p>Warm regards,</p>
        <p>
          <strong>{member.name}</strong> <br />
          {member.title} <br />
          Brahma Jyoti Holdings Limited
        </p>
      </div>
    </div>
  );
};

export default TestimonialPage;
